import './index.less'

const RechargeInstructions = (props:any) => {
  return (
    <div className='recharge-instructions'>
      <h3>充值后是否可退款？</h3>

      <p>充值后的余额可用于在平台内消费，无法退还，在充值操作时，请确认无误后再进行支付。</p>
    </div>
  )
}

export default RechargeInstructions